export enum AttendanceStatus {
  OPENED = 'opened',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
}
